/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_EditInputs */

const th_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แก้ไขทีม`)
};

const en_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit team`)
};

const ja_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームを編集`)
};

const zh_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑球队`)
};

const es_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar equipo`)
};

const pt_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar time`)
};

const id_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunting tim`)
};

const fr_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier l’équipe`)
};

const tl_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baguhin ang team`)
};

const vi_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa đội`)
};

const ko_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀 수정`)
};

const de_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team bearbeiten`)
};

const ru_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить команду`)
};

const tr_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takımı düzenle`)
};

const it_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica squadra`)
};

const pl_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edytuj drużynę`)
};

const uk_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Змінити команду`)
};

const hi_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम संपादित करें`)
};

const ar_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعديل الفريق`)
};

const ms_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunting pasukan`)
};

const bn_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল সম্পাদনা`)
};

const zh_tw2_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編輯球隊`)
};

const zh_hk2_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編輯球隊`)
};

const ur_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیم میں ترمیم`)
};

const fa_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ویرایش تیم`)
};

const sw_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hariri timu`)
};

const nl_team_edit = /** @type {(inputs: Team_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team bewerken`)
};

/**
* | output |
* | --- |
* | "Edit team" |
*
* @param {Team_EditInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const team_edit = /** @type {((inputs?: Team_EditInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_EditInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_team_edit(inputs)
	if (locale === "ja") return ja_team_edit(inputs)
	if (locale === "zh") return zh_team_edit(inputs)
	if (locale === "es") return es_team_edit(inputs)
	if (locale === "pt") return pt_team_edit(inputs)
	if (locale === "id") return id_team_edit(inputs)
	if (locale === "fr") return fr_team_edit(inputs)
	if (locale === "tl") return tl_team_edit(inputs)
	if (locale === "vi") return vi_team_edit(inputs)
	if (locale === "ko") return ko_team_edit(inputs)
	if (locale === "de") return de_team_edit(inputs)
	if (locale === "ru") return ru_team_edit(inputs)
	if (locale === "tr") return tr_team_edit(inputs)
	if (locale === "it") return it_team_edit(inputs)
	if (locale === "pl") return pl_team_edit(inputs)
	if (locale === "uk") return uk_team_edit(inputs)
	if (locale === "hi") return hi_team_edit(inputs)
	if (locale === "ar") return ar_team_edit(inputs)
	if (locale === "ms") return ms_team_edit(inputs)
	if (locale === "bn") return bn_team_edit(inputs)
	if (locale === "zh-TW") return zh_tw2_team_edit(inputs)
	if (locale === "zh-HK") return zh_hk2_team_edit(inputs)
	if (locale === "ur") return ur_team_edit(inputs)
	if (locale === "fa") return fa_team_edit(inputs)
	if (locale === "sw") return sw_team_edit(inputs)
	if (locale === "nl") return nl_team_edit(inputs)
	return en_team_edit(inputs)
});